require('./externalTransferValuesStep1.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @commmons
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKLink } = require('commonsComponents/OKLink');
const { OKInput } = require('commonsComponents/OKInput');
const { DragNDropUpload } = require('commonsComponents/dragNDropUpload');

// @components
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const UploadedDocumentRow = require('components/accounts/accountDirectDebitSteps/accountDirectDebitStep3/uploadedDocumentRow/uploadedDocumentRow');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @constants
const {
    BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER,
    NON_NUMERIC_REGEXP,
    EXTERNAL_TRANSFER_VALUES_GDPR_LINK,
    BROKER_ORIGIN_CONTRACT_NUMBER_MAX_LENGTH
} = require('constants/index');
const {
    BROKER_NO_DESTINATION_ACCOUNT_SELECTED,
    FILE_NUMBER_LIMIT,
    FILE_SIZE_LIMIT,
    FILE_TYPES,
    FILE_NAME_CHARS_LIMIT,
    FILE_NAME_REGEX
} = require('../constants');

class ExternalTransferValuesStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleDestinationAccount = this.handleDestinationAccount.bind(this);
        this.handleContractChange = this.handleContractChange.bind(this);
        this.handleBankNameChange = this.handleBankNameChange.bind(this);
    }

    buildStocksContractDropdownOptions() {
        const { immStocksContracts } = this.props;
        const processedStocksContract = immStocksContracts.map((entry, index) => {
            const associatedAccountBalance = {
                amount: entry.getIn(['associatedAccountBalance', 'amount']),
                currency: entry.getIn(['associatedAccountBalance', 'currency'])
            };

            return entry.merge({
                value: index,
                walletBalance: associatedAccountBalance
            });
        });

        return processedStocksContract.toJS();
    }

    errorMessage = (contractRequiredAlertVisible) => {
        let errorMessageText = formatText('externalTransferValues-externalTransferValues_contractErrorMessageWrong');
        if (contractRequiredAlertVisible) {
            errorMessageText = formatText('externalTransferValues-externalTransferValues_contractErrorMessageRequired');
        }

        return errorMessageText;
    }

    handleDestinationAccount(value){
        const selectOptions = this.buildStocksContractDropdownOptions();
        const {setDestinationAccount} = this.props;
        setDestinationAccount(value, selectOptions);
    }

    handleContractChange(event) {
        const { setContractNumber } = this.props;
        const value = event.target.value;
        setContractNumber(value.replace(NON_NUMERIC_REGEXP, ''));
    }

    buildContractNumberField() {
        const { immExternalTransferValues } = this.props;
        const immFirstStep = immExternalTransferValues.getIn(['steps', 0]);
        const contractNumber = immFirstStep.get('contractNumber');
        const contractNumberIsDirty = immFirstStep.get('contractNumberIsDirty');
        const errorState = contractNumberIsDirty && contractNumber.length < 20;
        const contractRequiredAlertVisible = contractNumberIsDirty && contractNumber === '';

        return (
            <OKInput
                autocomplete="off"
                label={formatText('externalTransferValues-externalTransferValues_originContractLabel')}
                type="text"
                value={contractNumber}
                maxlength={BROKER_ORIGIN_CONTRACT_NUMBER_MAX_LENGTH}
                errorState={errorState}
                errorMessage={this.errorMessage(contractRequiredAlertVisible)}
                onChange={this.handleContractChange}
            />
        );
    }

    handleBankNameChange(event) {
        this.props.setBankName(event.target.value);
    }

    buildBankNameField() {
        const { immExternalTransferValues } = this.props;
        const immFirstStep = immExternalTransferValues.getIn(['steps', 0]);
        const bankName = immFirstStep.get('bankName');
        const bankNameIsDirty = immFirstStep.get('bankNameIsDirty');
        const errorState = bankNameIsDirty && !bankName;

        return (
            <OKInput
                autocomplete="off"
                label={formatText('externalTransferValues-externalTransferValues_originBankLabel')}
                type="text"
                value={bankName}
                errorState={errorState}
                errorMessage={formatText('externalTransferValues-externalTransferValues_bankNameErrorMessage')}
                onChange={this.handleBankNameChange}
            />
        );
    }

    buildGDPRLink() {
        return (
            <OKLink inverse={true} to={EXTERNAL_TRANSFER_VALUES_GDPR_LINK} target="_blank">
                <FormattedText value="externalTransferValues-externalTransferValues_gdprLinkText"/>
            </OKLink>
        );
    }

    buildDocumentUploadSectionDescription() {
        return (
            <div className="external-transfer-values-step1__upload-section">
                <FormattedText
                    className="external-transfer-values-step1__sub-title"
                    value="externalTransferValues-externalTransferValues_uploadTitle"
                />
                <div className="external-transfer-values-step1__intructions">
                    <FormattedText
                        className="external-transfer-values-step1__description"
                        value="externalTransferValues-externalTransferValues_uploadDescription"
                    />
                    <p className="external-transfer-values-step1__intruction external-transfer-values-step1__intruction--first">
                        <FormattedText value="externalTransferValues-externalTransferValues_maximumSizeText"/>
                        <span className="external-transfer-values-step1__intruction-value">&nbsp;{FILE_SIZE_LIMIT/1000}MB</span>
                    </p>
                    <p className="external-transfer-values-step1__intruction">
                        <FormattedText value="externalTransferValues-externalTransferValues_fileTypeText"/>
                        <span className="external-transfer-values-step1__intruction-value">&nbsp;{FILE_TYPES.map((element) => element.toUpperCase()).join(', ')}.</span>
                    </p>
                </div>
            </div>
        );
    }

    buildAttachedDocumentInfo() {
        const { immStep, removeFile } = this.props;
        const filesAttached = immStep.get('filesAttached');
        return (
            <div className="external-transfer-values-step1__attachment-section">
                <UploadedDocumentRow
                    filesAttached={filesAttached}
                    hideDescription={true}
                    removeFile={removeFile}
                    uploadDocumentLabel="externalTransferValues-externalTransferValues_uploadRowLabel"
                />
            </div>
        );
    }

    buildUploadBox() {
        const { immStep, addFile } = this.props;
        const filesAttached = immStep.get('filesAttached');
        const fileSizeLimitInMBs = FILE_SIZE_LIMIT/1000;
        const texts = {
            sizeError: <FormattedText value="externalTransferValues-externalTransferValues_sizeAndTypeError" injectedStrings={[fileSizeLimitInMBs]} />,
            typeError: <FormattedText value="externalTransferValues-externalTransferValues_sizeAndTypeError" injectedStrings={[fileSizeLimitInMBs]} />,
            maxLengthError: <FormattedText value="externalTransferValues-externalTransferValues_fileNameLengthError" injectedStrings={[FILE_NAME_CHARS_LIMIT]} />,
            whiteListError: <FormattedText value="externalTransferValues-externalTransferValues_fileNameFormatError"/>,
        };
        const noFilesAttchedText = filesAttached.size === 0 && (
            <FormattedText
                value="externalTransferValues-externalTransferValues_noFilesText"
                className="external-transfer-values-step1__no-files-text"
            />
        );
        const uploadError = immStep.get('uploadError');
        const isUploading = immStep.get('isUploading');
        const uploadComponent = filesAttached.size < FILE_NUMBER_LIMIT && (
            <div className="col-xs-12 external-transfer-values-step1__upload-box-section">
                <DragNDropUpload
                    errorIconClass="icon-error external-transfer-values-step1__icon external-transfer-values-step1__icon--error"
                    errorMessage={formatText('externalTransferValues-externalTransferValues_fileUploadError')}
                    error={!!uploadError}
                    hideFormats={true}
                    hideShowAttachLink={true}
                    hideSizeLimit={true}
                    hideSuccessState={true}
                    hideUploadedFileList={true}
                    iconClass="icon-subir external-transfer-values-step1__icon"
                    idName="extractoBancario"
                    isModern={true}
                    isTrashVisible={true}
                    loading={isUploading}
                    maxLengthFileName={FILE_NAME_CHARS_LIMIT}
                    maxSize={FILE_SIZE_LIMIT}
                    onChange={addFile}
                    textDescription={formatText('externalTransferValues-externalTransferValues_dropBoxLabel')}
                    textLinkDescription={formatText('externalTransferValues-externalTransferValues_dropBoxLink')}
                    texts={texts}
                    validTypesFile={FILE_TYPES}
                    whiteListFileNameCharsRegExp={FILE_NAME_REGEX}
                />
            </div>
        );

        return(
            <div className="row">
                <div className="col-xs-12">
                    {noFilesAttchedText}
                </div>
                {uploadComponent}
            </div>
        );
    }

    render() {
        const { immStep } = this.props;
        const selectOptions = this.buildStocksContractDropdownOptions();
        const selectPlaceholderText = formatText('broker-stocksBuyStep1SelectPlaceholder');
        const destinationAccount = immStep.get('destinationAccount');
        const isDestinationAccountDirty = immStep.get('isDestinationAccountDirty');
        const contractNumberField = this.buildContractNumberField();
        const bankNameField = this.buildBankNameField();
        const documentUploadSectionDescription = this.buildDocumentUploadSectionDescription();
        const attachedDocumentInfo = this.buildAttachedDocumentInfo();
        const uploadBox = this.buildUploadBox();
        const accountError = destinationAccount === BROKER_NO_DESTINATION_ACCOUNT_SELECTED && isDestinationAccountDirty;

        return (
            <div className="external-transfer-values-step1">
                <h2 className="external-transfer-values-step1__title">
                    <FormattedText value="externalTransferValues-externalTransferValues_step1Title"/>
                </h2>
                <div>
                    <FormattedText
                        className="external-transfer-values-step1__sub-title"
                        value="externalTransferValues-externalTransferValues_originAccountPara"
                    />
                    <div className="row external-transfer-values-step1__iban-section">
                        <div className="external-transfer-values-step1__iban-section-account col-xs-4">
                            {contractNumberField}
                        </div>
                        <div className="external-transfer-values-step1__iban-section-bankentity col-xs-4">
                            {bankNameField}
                        </div>
                    </div>
                </div>
                <div className="external-transfer-values-step1__security-account-section">
                    <FormattedText
                        className="external-transfer-values-step1__sub-title external-transfer-values-step1__sub-title--margin-none"
                        value="externalTransferValues-externalTransferValues_destinationAccountPara"
                    />
                    <StocksContractDropdown
                        label="externalTransferValues-externalTransferValues_destinationAccountLabel"
                        onStockContractChange={this.handleDestinationAccount}
                        options={selectOptions}
                        selectedValue={destinationAccount}
                        placeholder={selectPlaceholderText}
                        modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER}
                        errorState={accountError}
                        errorMessage={formatText('broker-stocksBuyStep1NoAccountError')}
                    />
                </div>
                <div className="external-transfer-values-step1__information">
                    <OKMessage type="informative">
                        <FormattedText value="externalTransferValues-externalTransferValues_step1InformationMessage"/>
                    </OKMessage>
                </div>
                {documentUploadSectionDescription}
                {uploadBox}
                {attachedDocumentInfo}
                <div className="external-transfer-values-step1__gdpr-information">
                    <OKMessage type="informative" modifier="dark-bg">
                        <FormattedTextWithComponents
                            value="externalTransferValues-externalTransferValues_gdprInformation"
                            injectedComponents={[this.buildGDPRLink()]}
                        />
                    </OKMessage>
                </div>
            </div>
        );
    }
}

ExternalTransferValuesStep1.propTypes = {
    addFile: PropTypes.func.isRequired,
    immExternalTransferValues: PropTypes.object,
    immStep: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    removeFile: PropTypes.func.isRequired,
    setDestinationAccount: PropTypes.func.isRequired,
    setContractNumber: PropTypes.func.isRequired,
    setBankName: PropTypes.func.isRequired,
};
module.exports = ExternalTransferValuesStep1;
